import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "@redux/esign/actions";
import Wrapper from "./esignLandingPage.styles";
import esignAnimation from "../animatedGifs/icon-esign-optimised.gif";
import EsignModal from "./esignModal";
import { Loader } from "@components/loader";

export const EsignLandingPage = () => {
  const dispatch = useDispatch();
  const { queryString } = useSelector((state) => state.StartUp);
  const { pdfUrlData } = useSelector((state) => state.esign);
  const { id: accountExternalId } = queryString || {};
  const { downloadPdfFailed, isDownloadingPdf } = useSelector(
    (state) => state.esign
  );

  useEffect(() => {
    if (Object.keys(pdfUrlData).length === 0 && pdfUrlData.constructor === Object) {
      dispatch(actions.downloadPdfStart({ accountExternalId }));
    }
  }, [dispatch, accountExternalId, pdfUrlData]);

  const handleModalAction = () => {
    window.location.reload(true);
  };

  return (
    <Wrapper>
      <EsignModal
        visible={downloadPdfFailed}
        closeable={false}
        showButton={true}
        actionButtonText="Retry now"
        handleModalAction={handleModalAction}
      >
        Let's have another go at that. Click retry to reload this page.
      </EsignModal>
      {isDownloadingPdf ? (
        <Loader />
      ) : (
        <>
          <h1 className="esign-title">eSign Your Contract</h1>
          <img
            className="animated-gif-esign"
            src={esignAnimation}
            alt="esign"
          />
          <h2 className="esign-congratulations">Congratulations!!</h2>
          <p className="esign-content">
            Your loan is approved. Now all you need to do is eSign your contract
            and your funds can be on their way.
          </p>
        </>
      )}
    </Wrapper>
  );
};

export default EsignLandingPage;
